// source: tprmquestionnaire/tprmquestionnaire.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var authz_annotations_pb = require('../authz/annotations_pb.js');
goog.object.extend(proto, authz_annotations_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.tprmquestionnaire.AddVendorQuestionnaireRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.AddVendorQuestionnaireRequest.IntentCase', null, global);
goog.exportSymbol('proto.tprmquestionnaire.AddVendorQuestionnaireResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.AnswerInternally', null, global);
goog.exportSymbol('proto.tprmquestionnaire.AnsweredQuestion', null, global);
goog.exportSymbol('proto.tprmquestionnaire.AnsweredQuestionAttachment', null, global);
goog.exportSymbol('proto.tprmquestionnaire.AnsweredSection', null, global);
goog.exportSymbol('proto.tprmquestionnaire.Comment', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ConditionRule', null, global);
goog.exportSymbol('proto.tprmquestionnaire.CreateCommentRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.Empty', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ExportFormCsvRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ExportFormCsvResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.FormOption', null, global);
goog.exportSymbol('proto.tprmquestionnaire.FormOptionInput', null, global);
goog.exportSymbol('proto.tprmquestionnaire.FormQuestion', null, global);
goog.exportSymbol('proto.tprmquestionnaire.FormQuestionInput', null, global);
goog.exportSymbol('proto.tprmquestionnaire.FormSection', null, global);
goog.exportSymbol('proto.tprmquestionnaire.FormSectionInput', null, global);
goog.exportSymbol('proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.GetQuestionnaireFormRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.GetVendorQuestionnaireRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.GetVendorQuestionnaireResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ImportFormCsvRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ImportFormCsvResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListCommentThreadRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListCommentThreadResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListReceivedQuestionnairesRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListReceivedQuestionnairesResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListVendorQuestionnairesRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListVendorQuestionnairesResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.QuestionResponseType', null, global);
goog.exportSymbol('proto.tprmquestionnaire.QuestionnaireCommentAuthorSide', null, global);
goog.exportSymbol('proto.tprmquestionnaire.QuestionnaireForm', null, global);
goog.exportSymbol('proto.tprmquestionnaire.QuestionnaireRequestSummary', null, global);
goog.exportSymbol('proto.tprmquestionnaire.QuestionnaireTemplate', null, global);
goog.exportSymbol('proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SendToVendorUser', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SupplementalInput', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SupplementalInputKind', null, global);
goog.exportSymbol('proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.VendorQuestionnaireAttachment', null, global);
goog.exportSymbol('proto.tprmquestionnaire.VendorQuestionnaireVersionSummary', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.SupplementalInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.SupplementalInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.SupplementalInput.displayName = 'proto.tprmquestionnaire.SupplementalInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ConditionRule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ConditionRule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ConditionRule.displayName = 'proto.tprmquestionnaire.ConditionRule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.FormOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.FormOption.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.FormOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.FormOption.displayName = 'proto.tprmquestionnaire.FormOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.FormQuestion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.FormQuestion.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.FormQuestion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.FormQuestion.displayName = 'proto.tprmquestionnaire.FormQuestion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.FormSection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.FormSection.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.FormSection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.FormSection.displayName = 'proto.tprmquestionnaire.FormSection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.QuestionnaireForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.QuestionnaireForm.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.QuestionnaireForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.QuestionnaireForm.displayName = 'proto.tprmquestionnaire.QuestionnaireForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.QuestionnaireTemplate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.QuestionnaireTemplate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.QuestionnaireTemplate.displayName = 'proto.tprmquestionnaire.QuestionnaireTemplate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.displayName = 'proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.displayName = 'proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.GetQuestionnaireFormRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.GetQuestionnaireFormRequest.displayName = 'proto.tprmquestionnaire.GetQuestionnaireFormRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ExportFormCsvRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ExportFormCsvRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ExportFormCsvRequest.displayName = 'proto.tprmquestionnaire.ExportFormCsvRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ExportFormCsvResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ExportFormCsvResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ExportFormCsvResponse.displayName = 'proto.tprmquestionnaire.ExportFormCsvResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ImportFormCsvRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ImportFormCsvRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ImportFormCsvRequest.displayName = 'proto.tprmquestionnaire.ImportFormCsvRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ImportFormCsvResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ImportFormCsvResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ImportFormCsvResponse.displayName = 'proto.tprmquestionnaire.ImportFormCsvResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.tprmquestionnaire.AddVendorQuestionnaireRequest.oneofGroups_);
};
goog.inherits(proto.tprmquestionnaire.AddVendorQuestionnaireRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.AddVendorQuestionnaireRequest.displayName = 'proto.tprmquestionnaire.AddVendorQuestionnaireRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.SendToVendorUser = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.SendToVendorUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.SendToVendorUser.displayName = 'proto.tprmquestionnaire.SendToVendorUser';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.AnswerInternally = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.AnswerInternally, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.AnswerInternally.displayName = 'proto.tprmquestionnaire.AnswerInternally';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.AddVendorQuestionnaireResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.AddVendorQuestionnaireResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.AddVendorQuestionnaireResponse.displayName = 'proto.tprmquestionnaire.AddVendorQuestionnaireResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.displayName = 'proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse.displayName = 'proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest.displayName = 'proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse.displayName = 'proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest.displayName = 'proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse.displayName = 'proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.QuestionnaireRequestSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.QuestionnaireRequestSummary.displayName = 'proto.tprmquestionnaire.QuestionnaireRequestSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListVendorQuestionnairesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ListVendorQuestionnairesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListVendorQuestionnairesRequest.displayName = 'proto.tprmquestionnaire.ListVendorQuestionnairesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListVendorQuestionnairesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ListVendorQuestionnairesResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ListVendorQuestionnairesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListVendorQuestionnairesResponse.displayName = 'proto.tprmquestionnaire.ListVendorQuestionnairesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.GetVendorQuestionnaireRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.GetVendorQuestionnaireRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.GetVendorQuestionnaireRequest.displayName = 'proto.tprmquestionnaire.GetVendorQuestionnaireRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.GetVendorQuestionnaireResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.GetVendorQuestionnaireResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.GetVendorQuestionnaireResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.GetVendorQuestionnaireResponse.displayName = 'proto.tprmquestionnaire.GetVendorQuestionnaireResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ListReceivedQuestionnairesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.displayName = 'proto.tprmquestionnaire.ListReceivedQuestionnairesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ListReceivedQuestionnairesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.displayName = 'proto.tprmquestionnaire.ListReceivedQuestionnairesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest.displayName = 'proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.AnsweredQuestion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.AnsweredQuestion.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.AnsweredQuestion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.AnsweredQuestion.displayName = 'proto.tprmquestionnaire.AnsweredQuestion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.AnsweredQuestionAttachment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.AnsweredQuestionAttachment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.AnsweredQuestionAttachment.displayName = 'proto.tprmquestionnaire.AnsweredQuestionAttachment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.AnsweredSection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.AnsweredSection.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.AnsweredSection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.AnsweredSection.displayName = 'proto.tprmquestionnaire.AnsweredSection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest.displayName = 'proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.VendorQuestionnaireVersionSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.displayName = 'proto.tprmquestionnaire.VendorQuestionnaireVersionSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.displayName = 'proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest.displayName = 'proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.displayName = 'proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.displayName = 'proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.Comment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.Comment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.Comment.displayName = 'proto.tprmquestionnaire.Comment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.CreateCommentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.CreateCommentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.CreateCommentRequest.displayName = 'proto.tprmquestionnaire.CreateCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListCommentThreadRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ListCommentThreadRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListCommentThreadRequest.displayName = 'proto.tprmquestionnaire.ListCommentThreadRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListCommentThreadResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ListCommentThreadResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ListCommentThreadResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListCommentThreadResponse.displayName = 'proto.tprmquestionnaire.ListCommentThreadResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.Empty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.Empty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.Empty.displayName = 'proto.tprmquestionnaire.Empty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.FormOptionInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.FormOptionInput.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.FormOptionInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.FormOptionInput.displayName = 'proto.tprmquestionnaire.FormOptionInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.FormSectionInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.FormSectionInput.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.FormSectionInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.FormSectionInput.displayName = 'proto.tprmquestionnaire.FormSectionInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.FormQuestionInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.FormQuestionInput.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.FormQuestionInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.FormQuestionInput.displayName = 'proto.tprmquestionnaire.FormQuestionInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.displayName = 'proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse.displayName = 'proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest.displayName = 'proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.displayName = 'proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.displayName = 'proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest.displayName = 'proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest.displayName = 'proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest.displayName = 'proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest.displayName = 'proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest.displayName = 'proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest.displayName = 'proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.displayName = 'proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest.displayName = 'proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest.displayName = 'proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.VendorQuestionnaireAttachment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.VendorQuestionnaireAttachment.displayName = 'proto.tprmquestionnaire.VendorQuestionnaireAttachment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse.displayName = 'proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest.displayName = 'proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.displayName = 'proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.SupplementalInput.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.SupplementalInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.SupplementalInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SupplementalInput.toObject = function(includeInstance, msg) {
  var f, obj = {
    kind: jspb.Message.getFieldWithDefault(msg, 1, 0),
    label: jspb.Message.getFieldWithDefault(msg, 2, ""),
    required: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    isList: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.SupplementalInput}
 */
proto.tprmquestionnaire.SupplementalInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.SupplementalInput;
  return proto.tprmquestionnaire.SupplementalInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.SupplementalInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.SupplementalInput}
 */
proto.tprmquestionnaire.SupplementalInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.tprmquestionnaire.SupplementalInputKind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequired(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.SupplementalInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.SupplementalInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.SupplementalInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SupplementalInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequired();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getIsList();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional SupplementalInputKind kind = 1;
 * @return {!proto.tprmquestionnaire.SupplementalInputKind}
 */
proto.tprmquestionnaire.SupplementalInput.prototype.getKind = function() {
  return /** @type {!proto.tprmquestionnaire.SupplementalInputKind} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.tprmquestionnaire.SupplementalInputKind} value
 * @return {!proto.tprmquestionnaire.SupplementalInput} returns this
 */
proto.tprmquestionnaire.SupplementalInput.prototype.setKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.tprmquestionnaire.SupplementalInput.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SupplementalInput} returns this
 */
proto.tprmquestionnaire.SupplementalInput.prototype.setLabel = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.SupplementalInput} returns this
 */
proto.tprmquestionnaire.SupplementalInput.prototype.clearLabel = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.SupplementalInput.prototype.hasLabel = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool required = 3;
 * @return {boolean}
 */
proto.tprmquestionnaire.SupplementalInput.prototype.getRequired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tprmquestionnaire.SupplementalInput} returns this
 */
proto.tprmquestionnaire.SupplementalInput.prototype.setRequired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool is_list = 4;
 * @return {boolean}
 */
proto.tprmquestionnaire.SupplementalInput.prototype.getIsList = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tprmquestionnaire.SupplementalInput} returns this
 */
proto.tprmquestionnaire.SupplementalInput.prototype.setIsList = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ConditionRule.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ConditionRule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ConditionRule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ConditionRule.toObject = function(includeInstance, msg) {
  var f, obj = {
    dependsOnCoordinate: jspb.Message.getFieldWithDefault(msg, 1, ""),
    matchValue: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dependsOnQuestionId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ConditionRule}
 */
proto.tprmquestionnaire.ConditionRule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ConditionRule;
  return proto.tprmquestionnaire.ConditionRule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ConditionRule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ConditionRule}
 */
proto.tprmquestionnaire.ConditionRule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDependsOnCoordinate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatchValue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDependsOnQuestionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ConditionRule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ConditionRule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ConditionRule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ConditionRule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDependsOnCoordinate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMatchValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDependsOnQuestionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string depends_on_coordinate = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ConditionRule.prototype.getDependsOnCoordinate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ConditionRule} returns this
 */
proto.tprmquestionnaire.ConditionRule.prototype.setDependsOnCoordinate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string match_value = 2;
 * @return {string}
 */
proto.tprmquestionnaire.ConditionRule.prototype.getMatchValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ConditionRule} returns this
 */
proto.tprmquestionnaire.ConditionRule.prototype.setMatchValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string depends_on_question_id = 3;
 * @return {string}
 */
proto.tprmquestionnaire.ConditionRule.prototype.getDependsOnQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ConditionRule} returns this
 */
proto.tprmquestionnaire.ConditionRule.prototype.setDependsOnQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.FormOption.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.FormOption.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.FormOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.FormOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    label: jspb.Message.getFieldWithDefault(msg, 2, ""),
    displayOrder: jspb.Message.getFieldWithDefault(msg, 3, 0),
    supplementalList: jspb.Message.toObjectList(msg.getSupplementalList(),
    proto.tprmquestionnaire.SupplementalInput.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.FormOption}
 */
proto.tprmquestionnaire.FormOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.FormOption;
  return proto.tprmquestionnaire.FormOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.FormOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.FormOption}
 */
proto.tprmquestionnaire.FormOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayOrder(value);
      break;
    case 4:
      var value = new proto.tprmquestionnaire.SupplementalInput;
      reader.readMessage(value,proto.tprmquestionnaire.SupplementalInput.deserializeBinaryFromReader);
      msg.addSupplemental(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.FormOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.FormOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.FormOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDisplayOrder();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSupplementalList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.tprmquestionnaire.SupplementalInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.FormOption.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormOption} returns this
 */
proto.tprmquestionnaire.FormOption.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.tprmquestionnaire.FormOption.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormOption} returns this
 */
proto.tprmquestionnaire.FormOption.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 display_order = 3;
 * @return {number}
 */
proto.tprmquestionnaire.FormOption.prototype.getDisplayOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.FormOption} returns this
 */
proto.tprmquestionnaire.FormOption.prototype.setDisplayOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated SupplementalInput supplemental = 4;
 * @return {!Array<!proto.tprmquestionnaire.SupplementalInput>}
 */
proto.tprmquestionnaire.FormOption.prototype.getSupplementalList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.SupplementalInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.SupplementalInput, 4));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.SupplementalInput>} value
 * @return {!proto.tprmquestionnaire.FormOption} returns this
*/
proto.tprmquestionnaire.FormOption.prototype.setSupplementalList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.tprmquestionnaire.SupplementalInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.SupplementalInput}
 */
proto.tprmquestionnaire.FormOption.prototype.addSupplemental = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.tprmquestionnaire.SupplementalInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.FormOption} returns this
 */
proto.tprmquestionnaire.FormOption.prototype.clearSupplementalList = function() {
  return this.setSupplementalList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.FormQuestion.repeatedFields_ = [5,6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.FormQuestion.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.FormQuestion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.FormQuestion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormQuestion.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    text: jspb.Message.getFieldWithDefault(msg, 2, ""),
    responseType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    displayOrder: jspb.Message.getFieldWithDefault(msg, 4, 0),
    optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.tprmquestionnaire.FormOption.toObject, includeInstance),
    dependsOnList: jspb.Message.toObjectList(msg.getDependsOnList(),
    proto.tprmquestionnaire.ConditionRule.toObject, includeInstance),
    supplementalList: jspb.Message.toObjectList(msg.getSupplementalList(),
    proto.tprmquestionnaire.SupplementalInput.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.FormQuestion}
 */
proto.tprmquestionnaire.FormQuestion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.FormQuestion;
  return proto.tprmquestionnaire.FormQuestion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.FormQuestion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.FormQuestion}
 */
proto.tprmquestionnaire.FormQuestion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 3:
      var value = /** @type {!proto.tprmquestionnaire.QuestionResponseType} */ (reader.readEnum());
      msg.setResponseType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayOrder(value);
      break;
    case 5:
      var value = new proto.tprmquestionnaire.FormOption;
      reader.readMessage(value,proto.tprmquestionnaire.FormOption.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    case 6:
      var value = new proto.tprmquestionnaire.ConditionRule;
      reader.readMessage(value,proto.tprmquestionnaire.ConditionRule.deserializeBinaryFromReader);
      msg.addDependsOn(value);
      break;
    case 7:
      var value = new proto.tprmquestionnaire.SupplementalInput;
      reader.readMessage(value,proto.tprmquestionnaire.SupplementalInput.deserializeBinaryFromReader);
      msg.addSupplemental(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.FormQuestion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.FormQuestion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.FormQuestion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormQuestion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getResponseType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDisplayOrder();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.tprmquestionnaire.FormOption.serializeBinaryToWriter
    );
  }
  f = message.getDependsOnList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.tprmquestionnaire.ConditionRule.serializeBinaryToWriter
    );
  }
  f = message.getSupplementalList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.tprmquestionnaire.SupplementalInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.FormQuestion.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
 */
proto.tprmquestionnaire.FormQuestion.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.tprmquestionnaire.FormQuestion.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
 */
proto.tprmquestionnaire.FormQuestion.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional QuestionResponseType response_type = 3;
 * @return {!proto.tprmquestionnaire.QuestionResponseType}
 */
proto.tprmquestionnaire.FormQuestion.prototype.getResponseType = function() {
  return /** @type {!proto.tprmquestionnaire.QuestionResponseType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.tprmquestionnaire.QuestionResponseType} value
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
 */
proto.tprmquestionnaire.FormQuestion.prototype.setResponseType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int32 display_order = 4;
 * @return {number}
 */
proto.tprmquestionnaire.FormQuestion.prototype.getDisplayOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
 */
proto.tprmquestionnaire.FormQuestion.prototype.setDisplayOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated FormOption options = 5;
 * @return {!Array<!proto.tprmquestionnaire.FormOption>}
 */
proto.tprmquestionnaire.FormQuestion.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.FormOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.FormOption, 5));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.FormOption>} value
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
*/
proto.tprmquestionnaire.FormQuestion.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.tprmquestionnaire.FormOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.FormOption}
 */
proto.tprmquestionnaire.FormQuestion.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.tprmquestionnaire.FormOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
 */
proto.tprmquestionnaire.FormQuestion.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};


/**
 * repeated ConditionRule depends_on = 6;
 * @return {!Array<!proto.tprmquestionnaire.ConditionRule>}
 */
proto.tprmquestionnaire.FormQuestion.prototype.getDependsOnList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ConditionRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ConditionRule, 6));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ConditionRule>} value
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
*/
proto.tprmquestionnaire.FormQuestion.prototype.setDependsOnList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.tprmquestionnaire.ConditionRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ConditionRule}
 */
proto.tprmquestionnaire.FormQuestion.prototype.addDependsOn = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.tprmquestionnaire.ConditionRule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
 */
proto.tprmquestionnaire.FormQuestion.prototype.clearDependsOnList = function() {
  return this.setDependsOnList([]);
};


/**
 * repeated SupplementalInput supplemental = 7;
 * @return {!Array<!proto.tprmquestionnaire.SupplementalInput>}
 */
proto.tprmquestionnaire.FormQuestion.prototype.getSupplementalList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.SupplementalInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.SupplementalInput, 7));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.SupplementalInput>} value
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
*/
proto.tprmquestionnaire.FormQuestion.prototype.setSupplementalList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.tprmquestionnaire.SupplementalInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.SupplementalInput}
 */
proto.tprmquestionnaire.FormQuestion.prototype.addSupplemental = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.tprmquestionnaire.SupplementalInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
 */
proto.tprmquestionnaire.FormQuestion.prototype.clearSupplementalList = function() {
  return this.setSupplementalList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.FormSection.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.FormSection.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.FormSection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.FormSection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormSection.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    displayOrder: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dependsOnList: jspb.Message.toObjectList(msg.getDependsOnList(),
    proto.tprmquestionnaire.ConditionRule.toObject, includeInstance),
    questionsList: jspb.Message.toObjectList(msg.getQuestionsList(),
    proto.tprmquestionnaire.FormQuestion.toObject, includeInstance),
    description: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.FormSection}
 */
proto.tprmquestionnaire.FormSection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.FormSection;
  return proto.tprmquestionnaire.FormSection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.FormSection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.FormSection}
 */
proto.tprmquestionnaire.FormSection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayOrder(value);
      break;
    case 4:
      var value = new proto.tprmquestionnaire.ConditionRule;
      reader.readMessage(value,proto.tprmquestionnaire.ConditionRule.deserializeBinaryFromReader);
      msg.addDependsOn(value);
      break;
    case 5:
      var value = new proto.tprmquestionnaire.FormQuestion;
      reader.readMessage(value,proto.tprmquestionnaire.FormQuestion.deserializeBinaryFromReader);
      msg.addQuestions(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.FormSection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.FormSection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.FormSection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormSection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDisplayOrder();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDependsOnList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.tprmquestionnaire.ConditionRule.serializeBinaryToWriter
    );
  }
  f = message.getQuestionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.tprmquestionnaire.FormQuestion.serializeBinaryToWriter
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.FormSection.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormSection} returns this
 */
proto.tprmquestionnaire.FormSection.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.tprmquestionnaire.FormSection.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormSection} returns this
 */
proto.tprmquestionnaire.FormSection.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 display_order = 3;
 * @return {number}
 */
proto.tprmquestionnaire.FormSection.prototype.getDisplayOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.FormSection} returns this
 */
proto.tprmquestionnaire.FormSection.prototype.setDisplayOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated ConditionRule depends_on = 4;
 * @return {!Array<!proto.tprmquestionnaire.ConditionRule>}
 */
proto.tprmquestionnaire.FormSection.prototype.getDependsOnList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ConditionRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ConditionRule, 4));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ConditionRule>} value
 * @return {!proto.tprmquestionnaire.FormSection} returns this
*/
proto.tprmquestionnaire.FormSection.prototype.setDependsOnList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.tprmquestionnaire.ConditionRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ConditionRule}
 */
proto.tprmquestionnaire.FormSection.prototype.addDependsOn = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.tprmquestionnaire.ConditionRule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.FormSection} returns this
 */
proto.tprmquestionnaire.FormSection.prototype.clearDependsOnList = function() {
  return this.setDependsOnList([]);
};


/**
 * repeated FormQuestion questions = 5;
 * @return {!Array<!proto.tprmquestionnaire.FormQuestion>}
 */
proto.tprmquestionnaire.FormSection.prototype.getQuestionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.FormQuestion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.FormQuestion, 5));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.FormQuestion>} value
 * @return {!proto.tprmquestionnaire.FormSection} returns this
*/
proto.tprmquestionnaire.FormSection.prototype.setQuestionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.tprmquestionnaire.FormQuestion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.FormQuestion}
 */
proto.tprmquestionnaire.FormSection.prototype.addQuestions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.tprmquestionnaire.FormQuestion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.FormSection} returns this
 */
proto.tprmquestionnaire.FormSection.prototype.clearQuestionsList = function() {
  return this.setQuestionsList([]);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.tprmquestionnaire.FormSection.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormSection} returns this
 */
proto.tprmquestionnaire.FormSection.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.QuestionnaireForm.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.QuestionnaireForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.QuestionnaireForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionnaireForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    version: jspb.Message.getFieldWithDefault(msg, 4, 0),
    sectionsList: jspb.Message.toObjectList(msg.getSectionsList(),
    proto.tprmquestionnaire.FormSection.toObject, includeInstance),
    category: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.QuestionnaireForm}
 */
proto.tprmquestionnaire.QuestionnaireForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.QuestionnaireForm;
  return proto.tprmquestionnaire.QuestionnaireForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.QuestionnaireForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.QuestionnaireForm}
 */
proto.tprmquestionnaire.QuestionnaireForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 5:
      var value = new proto.tprmquestionnaire.FormSection;
      reader.readMessage(value,proto.tprmquestionnaire.FormSection.deserializeBinaryFromReader);
      msg.addSections(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.QuestionnaireForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.QuestionnaireForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionnaireForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.tprmquestionnaire.FormSection.serializeBinaryToWriter
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireForm} returns this
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireForm} returns this
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireForm} returns this
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 version = 4;
 * @return {number}
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.QuestionnaireForm} returns this
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated FormSection sections = 5;
 * @return {!Array<!proto.tprmquestionnaire.FormSection>}
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.getSectionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.FormSection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.FormSection, 5));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.FormSection>} value
 * @return {!proto.tprmquestionnaire.QuestionnaireForm} returns this
*/
proto.tprmquestionnaire.QuestionnaireForm.prototype.setSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.tprmquestionnaire.FormSection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.FormSection}
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.addSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.tprmquestionnaire.FormSection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.QuestionnaireForm} returns this
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.clearSectionsList = function() {
  return this.setSectionsList([]);
};


/**
 * optional string category = 6;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireForm} returns this
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.QuestionnaireTemplate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.QuestionnaireTemplate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionnaireTemplate.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    questionnaireFormId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
    category: jspb.Message.getFieldWithDefault(msg, 6, ""),
    sectionCount: jspb.Message.getFieldWithDefault(msg, 7, 0),
    questionCount: jspb.Message.getFieldWithDefault(msg, 8, 0),
    isBuiltIn: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.QuestionnaireTemplate;
  return proto.tprmquestionnaire.QuestionnaireTemplate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.QuestionnaireTemplate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSectionCount(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionCount(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsBuiltIn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.QuestionnaireTemplate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.QuestionnaireTemplate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionnaireTemplate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestionnaireFormId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSectionCount();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getQuestionCount();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getIsBuiltIn();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate} returns this
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string questionnaire_form_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.getQuestionnaireFormId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate} returns this
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.setQuestionnaireFormId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate} returns this
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate} returns this
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 updated_at = 5;
 * @return {number}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate} returns this
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string category = 6;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate} returns this
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 section_count = 7;
 * @return {number}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.getSectionCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate} returns this
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.setSectionCount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 question_count = 8;
 * @return {number}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.getQuestionCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate} returns this
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.setQuestionCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool is_built_in = 9;
 * @return {boolean}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.getIsBuiltIn = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate} returns this
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.setIsBuiltIn = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest;
  return proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    templatesList: jspb.Message.toObjectList(msg.getTemplatesList(),
    proto.tprmquestionnaire.QuestionnaireTemplate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse;
  return proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tprmquestionnaire.QuestionnaireTemplate;
      reader.readMessage(value,proto.tprmquestionnaire.QuestionnaireTemplate.deserializeBinaryFromReader);
      msg.addTemplates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTemplatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tprmquestionnaire.QuestionnaireTemplate.serializeBinaryToWriter
    );
  }
};


/**
 * repeated QuestionnaireTemplate templates = 1;
 * @return {!Array<!proto.tprmquestionnaire.QuestionnaireTemplate>}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.prototype.getTemplatesList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.QuestionnaireTemplate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.QuestionnaireTemplate, 1));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.QuestionnaireTemplate>} value
 * @return {!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse} returns this
*/
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.prototype.setTemplatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tprmquestionnaire.QuestionnaireTemplate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.prototype.addTemplates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tprmquestionnaire.QuestionnaireTemplate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse} returns this
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.prototype.clearTemplatesList = function() {
  return this.setTemplatesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.GetQuestionnaireFormRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.GetQuestionnaireFormRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireFormId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.GetQuestionnaireFormRequest}
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.GetQuestionnaireFormRequest;
  return proto.tprmquestionnaire.GetQuestionnaireFormRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.GetQuestionnaireFormRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.GetQuestionnaireFormRequest}
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.GetQuestionnaireFormRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.GetQuestionnaireFormRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireFormId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string questionnaire_form_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest.prototype.getQuestionnaireFormId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireFormRequest} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest.prototype.setQuestionnaireFormId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ExportFormCsvRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ExportFormCsvRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ExportFormCsvRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ExportFormCsvRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireFormId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ExportFormCsvRequest}
 */
proto.tprmquestionnaire.ExportFormCsvRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ExportFormCsvRequest;
  return proto.tprmquestionnaire.ExportFormCsvRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ExportFormCsvRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ExportFormCsvRequest}
 */
proto.tprmquestionnaire.ExportFormCsvRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ExportFormCsvRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ExportFormCsvRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ExportFormCsvRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ExportFormCsvRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireFormId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string questionnaire_form_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ExportFormCsvRequest.prototype.getQuestionnaireFormId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ExportFormCsvRequest} returns this
 */
proto.tprmquestionnaire.ExportFormCsvRequest.prototype.setQuestionnaireFormId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ExportFormCsvResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ExportFormCsvResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ExportFormCsvResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ExportFormCsvResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    csv: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ExportFormCsvResponse}
 */
proto.tprmquestionnaire.ExportFormCsvResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ExportFormCsvResponse;
  return proto.tprmquestionnaire.ExportFormCsvResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ExportFormCsvResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ExportFormCsvResponse}
 */
proto.tprmquestionnaire.ExportFormCsvResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCsv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ExportFormCsvResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ExportFormCsvResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ExportFormCsvResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ExportFormCsvResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCsv();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string csv = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ExportFormCsvResponse.prototype.getCsv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ExportFormCsvResponse} returns this
 */
proto.tprmquestionnaire.ExportFormCsvResponse.prototype.setCsv = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ImportFormCsvRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ImportFormCsvRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ImportFormCsvRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ImportFormCsvRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    csv: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ImportFormCsvRequest}
 */
proto.tprmquestionnaire.ImportFormCsvRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ImportFormCsvRequest;
  return proto.tprmquestionnaire.ImportFormCsvRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ImportFormCsvRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ImportFormCsvRequest}
 */
proto.tprmquestionnaire.ImportFormCsvRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCsv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ImportFormCsvRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ImportFormCsvRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ImportFormCsvRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ImportFormCsvRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCsv();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ImportFormCsvRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ImportFormCsvRequest} returns this
 */
proto.tprmquestionnaire.ImportFormCsvRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string csv = 2;
 * @return {string}
 */
proto.tprmquestionnaire.ImportFormCsvRequest.prototype.getCsv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ImportFormCsvRequest} returns this
 */
proto.tprmquestionnaire.ImportFormCsvRequest.prototype.setCsv = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ImportFormCsvResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ImportFormCsvResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ImportFormCsvResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ImportFormCsvResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireFormId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ImportFormCsvResponse}
 */
proto.tprmquestionnaire.ImportFormCsvResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ImportFormCsvResponse;
  return proto.tprmquestionnaire.ImportFormCsvResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ImportFormCsvResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ImportFormCsvResponse}
 */
proto.tprmquestionnaire.ImportFormCsvResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ImportFormCsvResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ImportFormCsvResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ImportFormCsvResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ImportFormCsvResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireFormId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string questionnaire_form_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ImportFormCsvResponse.prototype.getQuestionnaireFormId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ImportFormCsvResponse} returns this
 */
proto.tprmquestionnaire.ImportFormCsvResponse.prototype.setQuestionnaireFormId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.oneofGroups_ = [[4,5]];

/**
 * @enum {number}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.IntentCase = {
  INTENT_NOT_SET: 0,
  SEND: 4,
  ANSWER_INTERNALLY: 5
};

/**
 * @return {proto.tprmquestionnaire.AddVendorQuestionnaireRequest.IntentCase}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.prototype.getIntentCase = function() {
  return /** @type {proto.tprmquestionnaire.AddVendorQuestionnaireRequest.IntentCase} */(jspb.Message.computeOneofCase(this, proto.tprmquestionnaire.AddVendorQuestionnaireRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.AddVendorQuestionnaireRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireTemplateId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    vendorId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    send: (f = msg.getSend()) && proto.tprmquestionnaire.SendToVendorUser.toObject(includeInstance, f),
    answerInternally: (f = msg.getAnswerInternally()) && proto.tprmquestionnaire.AnswerInternally.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.AddVendorQuestionnaireRequest;
  return proto.tprmquestionnaire.AddVendorQuestionnaireRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireTemplateId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = new proto.tprmquestionnaire.SendToVendorUser;
      reader.readMessage(value,proto.tprmquestionnaire.SendToVendorUser.deserializeBinaryFromReader);
      msg.setSend(value);
      break;
    case 5:
      var value = new proto.tprmquestionnaire.AnswerInternally;
      reader.readMessage(value,proto.tprmquestionnaire.AnswerInternally.deserializeBinaryFromReader);
      msg.setAnswerInternally(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.AddVendorQuestionnaireRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireTemplateId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVendorId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSend();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.tprmquestionnaire.SendToVendorUser.serializeBinaryToWriter
    );
  }
  f = message.getAnswerInternally();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.tprmquestionnaire.AnswerInternally.serializeBinaryToWriter
    );
  }
};


/**
 * optional string questionnaire_template_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.prototype.getQuestionnaireTemplateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.prototype.setQuestionnaireTemplateId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string vendor_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.prototype.getVendorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.prototype.setVendorId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional SendToVendorUser send = 4;
 * @return {?proto.tprmquestionnaire.SendToVendorUser}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.prototype.getSend = function() {
  return /** @type{?proto.tprmquestionnaire.SendToVendorUser} */ (
    jspb.Message.getWrapperField(this, proto.tprmquestionnaire.SendToVendorUser, 4));
};


/**
 * @param {?proto.tprmquestionnaire.SendToVendorUser|undefined} value
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest} returns this
*/
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.prototype.setSend = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.tprmquestionnaire.AddVendorQuestionnaireRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.prototype.clearSend = function() {
  return this.setSend(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.prototype.hasSend = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional AnswerInternally answer_internally = 5;
 * @return {?proto.tprmquestionnaire.AnswerInternally}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.prototype.getAnswerInternally = function() {
  return /** @type{?proto.tprmquestionnaire.AnswerInternally} */ (
    jspb.Message.getWrapperField(this, proto.tprmquestionnaire.AnswerInternally, 5));
};


/**
 * @param {?proto.tprmquestionnaire.AnswerInternally|undefined} value
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest} returns this
*/
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.prototype.setAnswerInternally = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.tprmquestionnaire.AddVendorQuestionnaireRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.prototype.clearAnswerInternally = function() {
  return this.setAnswerInternally(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireRequest.prototype.hasAnswerInternally = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.SendToVendorUser.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.SendToVendorUser.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.SendToVendorUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SendToVendorUser.toObject = function(includeInstance, msg) {
  var f, obj = {
    vendorUserId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    dueDate: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.SendToVendorUser}
 */
proto.tprmquestionnaire.SendToVendorUser.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.SendToVendorUser;
  return proto.tprmquestionnaire.SendToVendorUser.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.SendToVendorUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.SendToVendorUser}
 */
proto.tprmquestionnaire.SendToVendorUser.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDueDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.SendToVendorUser.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.SendToVendorUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.SendToVendorUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SendToVendorUser.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVendorUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string vendor_user_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.SendToVendorUser.prototype.getVendorUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SendToVendorUser} returns this
 */
proto.tprmquestionnaire.SendToVendorUser.prototype.setVendorUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 due_date = 2;
 * @return {number}
 */
proto.tprmquestionnaire.SendToVendorUser.prototype.getDueDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.SendToVendorUser} returns this
 */
proto.tprmquestionnaire.SendToVendorUser.prototype.setDueDate = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.SendToVendorUser} returns this
 */
proto.tprmquestionnaire.SendToVendorUser.prototype.clearDueDate = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.SendToVendorUser.prototype.hasDueDate = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.AnswerInternally.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.AnswerInternally.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.AnswerInternally} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.AnswerInternally.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.AnswerInternally}
 */
proto.tprmquestionnaire.AnswerInternally.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.AnswerInternally;
  return proto.tprmquestionnaire.AnswerInternally.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.AnswerInternally} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.AnswerInternally}
 */
proto.tprmquestionnaire.AnswerInternally.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.AnswerInternally.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.AnswerInternally.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.AnswerInternally} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.AnswerInternally.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.AddVendorQuestionnaireResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.AddVendorQuestionnaireResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.AddVendorQuestionnaireResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireResponse}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.AddVendorQuestionnaireResponse;
  return proto.tprmquestionnaire.AddVendorQuestionnaireResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.AddVendorQuestionnaireResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireResponse}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.AddVendorQuestionnaireResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.AddVendorQuestionnaireResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.AddVendorQuestionnaireResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string questionnaire_request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireResponse.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.AddVendorQuestionnaireResponse.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dueDate: jspb.Message.getFieldWithDefault(msg, 3, 0),
    assigneeUserId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest}
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest;
  return proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest}
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDueDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigneeUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string questionnaire_request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.prototype.setDescription = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.prototype.clearDescription = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.prototype.hasDescription = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 due_date = 3;
 * @return {number}
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.prototype.getDueDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.prototype.setDueDate = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.prototype.clearDueDate = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.prototype.hasDueDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string assignee_user_id = 4;
 * @return {string}
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.prototype.getAssigneeUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.prototype.setAssigneeUserId = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.prototype.clearAssigneeUserId = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest.prototype.hasAssigneeUserId = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse}
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse;
  return proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse}
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest}
 */
proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest;
  return proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest}
 */
proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string questionnaire_request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse}
 */
proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse;
  return proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse}
 */
proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, ""),
    note: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest}
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest;
  return proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest}
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string questionnaire_request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest} returns this
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest} returns this
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string note = 3;
 * @return {string}
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest} returns this
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusRequest.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse}
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse;
  return proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse}
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SetVendorQuestionnaireStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.QuestionnaireRequestSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.QuestionnaireRequestSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    vendorId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    requestingOrgName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    dueDate: jspb.Message.getFieldWithDefault(msg, 6, 0),
    status: jspb.Message.getFieldWithDefault(msg, 7, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 8, 0),
    vendorName: jspb.Message.getFieldWithDefault(msg, 9, ""),
    vendorUserName: jspb.Message.getFieldWithDefault(msg, 10, ""),
    vendorUserEmail: jspb.Message.getFieldWithDefault(msg, 11, ""),
    sentAt: jspb.Message.getFieldWithDefault(msg, 12, 0),
    answeredByUserEmail: jspb.Message.getFieldWithDefault(msg, 13, ""),
    answeredByUserName: jspb.Message.getFieldWithDefault(msg, 14, ""),
    answeringRequestId: jspb.Message.getFieldWithDefault(msg, 15, ""),
    statusNote: jspb.Message.getFieldWithDefault(msg, 16, ""),
    statusSetByName: jspb.Message.getFieldWithDefault(msg, 17, ""),
    statusSetAt: jspb.Message.getFieldWithDefault(msg, 18, 0),
    assigneeUserId: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.QuestionnaireRequestSummary;
  return proto.tprmquestionnaire.QuestionnaireRequestSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.QuestionnaireRequestSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestingOrgName(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDueDate(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorName(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorUserName(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorUserEmail(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSentAt(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnsweredByUserEmail(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnsweredByUserName(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnsweringRequestId(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusNote(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusSetByName(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStatusSetAt(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigneeUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.QuestionnaireRequestSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.QuestionnaireRequestSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVendorId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRequestingOrgName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getVendorName();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getVendorUserName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getVendorUserEmail();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getAnsweredByUserEmail();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getAnsweredByUserName();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getAnsweringRequestId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getStatusNote();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getStatusSetByName();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getAssigneeUserId();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string vendor_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getVendorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setVendorId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string requesting_org_name = 5;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getRequestingOrgName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setRequestingOrgName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 due_date = 6;
 * @return {number}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getDueDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setDueDate = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.clearDueDate = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.hasDueDate = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string status = 7;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 created_at = 8;
 * @return {number}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string vendor_name = 9;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getVendorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setVendorName = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string vendor_user_name = 10;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getVendorUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setVendorUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string vendor_user_email = 11;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getVendorUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setVendorUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int64 sent_at = 12;
 * @return {number}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getSentAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setSentAt = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.clearSentAt = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.hasSentAt = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string answered_by_user_email = 13;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getAnsweredByUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setAnsweredByUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string answered_by_user_name = 14;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getAnsweredByUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setAnsweredByUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string answering_request_id = 15;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getAnsweringRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setAnsweringRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string status_note = 16;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getStatusNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setStatusNote = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string status_set_by_name = 17;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getStatusSetByName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setStatusSetByName = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional int64 status_set_at = 18;
 * @return {number}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getStatusSetAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setStatusSetAt = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.clearStatusSetAt = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.hasStatusSetAt = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional string assignee_user_id = 19;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getAssigneeUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setAssigneeUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListVendorQuestionnairesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListVendorQuestionnairesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnairesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListVendorQuestionnairesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    vendorId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnairesRequest}
 */
proto.tprmquestionnaire.ListVendorQuestionnairesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListVendorQuestionnairesRequest;
  return proto.tprmquestionnaire.ListVendorQuestionnairesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnairesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnairesRequest}
 */
proto.tprmquestionnaire.ListVendorQuestionnairesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListVendorQuestionnairesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListVendorQuestionnairesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnairesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListVendorQuestionnairesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string vendor_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ListVendorQuestionnairesRequest.prototype.getVendorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnairesRequest} returns this
 */
proto.tprmquestionnaire.ListVendorQuestionnairesRequest.prototype.setVendorId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnairesRequest} returns this
 */
proto.tprmquestionnaire.ListVendorQuestionnairesRequest.prototype.clearVendorId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.ListVendorQuestionnairesRequest.prototype.hasVendorId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ListVendorQuestionnairesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListVendorQuestionnairesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListVendorQuestionnairesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnairesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListVendorQuestionnairesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestsList: jspb.Message.toObjectList(msg.getRequestsList(),
    proto.tprmquestionnaire.QuestionnaireRequestSummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnairesResponse}
 */
proto.tprmquestionnaire.ListVendorQuestionnairesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListVendorQuestionnairesResponse;
  return proto.tprmquestionnaire.ListVendorQuestionnairesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnairesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnairesResponse}
 */
proto.tprmquestionnaire.ListVendorQuestionnairesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tprmquestionnaire.QuestionnaireRequestSummary;
      reader.readMessage(value,proto.tprmquestionnaire.QuestionnaireRequestSummary.deserializeBinaryFromReader);
      msg.addRequests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListVendorQuestionnairesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListVendorQuestionnairesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnairesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListVendorQuestionnairesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tprmquestionnaire.QuestionnaireRequestSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated QuestionnaireRequestSummary requests = 1;
 * @return {!Array<!proto.tprmquestionnaire.QuestionnaireRequestSummary>}
 */
proto.tprmquestionnaire.ListVendorQuestionnairesResponse.prototype.getRequestsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.QuestionnaireRequestSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.QuestionnaireRequestSummary, 1));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.QuestionnaireRequestSummary>} value
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnairesResponse} returns this
*/
proto.tprmquestionnaire.ListVendorQuestionnairesResponse.prototype.setRequestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tprmquestionnaire.QuestionnaireRequestSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary}
 */
proto.tprmquestionnaire.ListVendorQuestionnairesResponse.prototype.addRequests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tprmquestionnaire.QuestionnaireRequestSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnairesResponse} returns this
 */
proto.tprmquestionnaire.ListVendorQuestionnairesResponse.prototype.clearRequestsList = function() {
  return this.setRequestsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.GetVendorQuestionnaireRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetVendorQuestionnaireRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireRequest}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.GetVendorQuestionnaireRequest;
  return proto.tprmquestionnaire.GetVendorQuestionnaireRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireRequest}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.GetVendorQuestionnaireRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetVendorQuestionnaireRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string questionnaire_request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireRequest.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.GetVendorQuestionnaireRequest.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.GetVendorQuestionnaireResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.GetVendorQuestionnaireResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetVendorQuestionnaireResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaire: (f = msg.getQuestionnaire()) && proto.tprmquestionnaire.QuestionnaireRequestSummary.toObject(includeInstance, f),
    siblingRequestIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireResponse}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.GetVendorQuestionnaireResponse;
  return proto.tprmquestionnaire.GetVendorQuestionnaireResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireResponse}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tprmquestionnaire.QuestionnaireRequestSummary;
      reader.readMessage(value,proto.tprmquestionnaire.QuestionnaireRequestSummary.deserializeBinaryFromReader);
      msg.setQuestionnaire(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addSiblingRequestIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.GetVendorQuestionnaireResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetVendorQuestionnaireResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaire();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.tprmquestionnaire.QuestionnaireRequestSummary.serializeBinaryToWriter
    );
  }
  f = message.getSiblingRequestIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional QuestionnaireRequestSummary questionnaire = 1;
 * @return {?proto.tprmquestionnaire.QuestionnaireRequestSummary}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireResponse.prototype.getQuestionnaire = function() {
  return /** @type{?proto.tprmquestionnaire.QuestionnaireRequestSummary} */ (
    jspb.Message.getWrapperField(this, proto.tprmquestionnaire.QuestionnaireRequestSummary, 1));
};


/**
 * @param {?proto.tprmquestionnaire.QuestionnaireRequestSummary|undefined} value
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireResponse} returns this
*/
proto.tprmquestionnaire.GetVendorQuestionnaireResponse.prototype.setQuestionnaire = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetVendorQuestionnaireResponse.prototype.clearQuestionnaire = function() {
  return this.setQuestionnaire(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireResponse.prototype.hasQuestionnaire = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated string sibling_request_ids = 2;
 * @return {!Array<string>}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireResponse.prototype.getSiblingRequestIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetVendorQuestionnaireResponse.prototype.setSiblingRequestIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetVendorQuestionnaireResponse.prototype.addSiblingRequestIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetVendorQuestionnaireResponse.prototype.clearSiblingRequestIdsList = function() {
  return this.setSiblingRequestIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListReceivedQuestionnairesRequest;
  return proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestsList: jspb.Message.toObjectList(msg.getRequestsList(),
    proto.tprmquestionnaire.QuestionnaireRequestSummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListReceivedQuestionnairesResponse;
  return proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tprmquestionnaire.QuestionnaireRequestSummary;
      reader.readMessage(value,proto.tprmquestionnaire.QuestionnaireRequestSummary.deserializeBinaryFromReader);
      msg.addRequests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tprmquestionnaire.QuestionnaireRequestSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated QuestionnaireRequestSummary requests = 1;
 * @return {!Array<!proto.tprmquestionnaire.QuestionnaireRequestSummary>}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.prototype.getRequestsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.QuestionnaireRequestSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.QuestionnaireRequestSummary, 1));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.QuestionnaireRequestSummary>} value
 * @return {!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse} returns this
*/
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.prototype.setRequestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tprmquestionnaire.QuestionnaireRequestSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.prototype.addRequests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tprmquestionnaire.QuestionnaireRequestSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse} returns this
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.prototype.clearRequestsList = function() {
  return this.setRequestsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest;
  return proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string questionnaire_request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest} returns this
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.AnsweredQuestion.repeatedFields_ = [5,6,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.AnsweredQuestion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.AnsweredQuestion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.AnsweredQuestion.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    text: jspb.Message.getFieldWithDefault(msg, 2, ""),
    responseType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    displayOrder: jspb.Message.getFieldWithDefault(msg, 4, 0),
    optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.tprmquestionnaire.FormOption.toObject, includeInstance),
    dependsOnList: jspb.Message.toObjectList(msg.getDependsOnList(),
    proto.tprmquestionnaire.ConditionRule.toObject, includeInstance),
    answerValue: jspb.Message.getFieldWithDefault(msg, 7, ""),
    attachmentsList: jspb.Message.toObjectList(msg.getAttachmentsList(),
    proto.tprmquestionnaire.AnsweredQuestionAttachment.toObject, includeInstance),
    supplementalText: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.AnsweredQuestion}
 */
proto.tprmquestionnaire.AnsweredQuestion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.AnsweredQuestion;
  return proto.tprmquestionnaire.AnsweredQuestion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.AnsweredQuestion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.AnsweredQuestion}
 */
proto.tprmquestionnaire.AnsweredQuestion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 3:
      var value = /** @type {!proto.tprmquestionnaire.QuestionResponseType} */ (reader.readEnum());
      msg.setResponseType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayOrder(value);
      break;
    case 5:
      var value = new proto.tprmquestionnaire.FormOption;
      reader.readMessage(value,proto.tprmquestionnaire.FormOption.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    case 6:
      var value = new proto.tprmquestionnaire.ConditionRule;
      reader.readMessage(value,proto.tprmquestionnaire.ConditionRule.deserializeBinaryFromReader);
      msg.addDependsOn(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerValue(value);
      break;
    case 8:
      var value = new proto.tprmquestionnaire.AnsweredQuestionAttachment;
      reader.readMessage(value,proto.tprmquestionnaire.AnsweredQuestionAttachment.deserializeBinaryFromReader);
      msg.addAttachments(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSupplementalText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.AnsweredQuestion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.AnsweredQuestion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.AnsweredQuestion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getResponseType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDisplayOrder();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.tprmquestionnaire.FormOption.serializeBinaryToWriter
    );
  }
  f = message.getDependsOnList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.tprmquestionnaire.ConditionRule.serializeBinaryToWriter
    );
  }
  f = message.getAnswerValue();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAttachmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.tprmquestionnaire.AnsweredQuestionAttachment.serializeBinaryToWriter
    );
  }
  f = message.getSupplementalText();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string question_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.getQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.AnsweredQuestion} returns this
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.AnsweredQuestion} returns this
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional QuestionResponseType response_type = 3;
 * @return {!proto.tprmquestionnaire.QuestionResponseType}
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.getResponseType = function() {
  return /** @type {!proto.tprmquestionnaire.QuestionResponseType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.tprmquestionnaire.QuestionResponseType} value
 * @return {!proto.tprmquestionnaire.AnsweredQuestion} returns this
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.setResponseType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int32 display_order = 4;
 * @return {number}
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.getDisplayOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.AnsweredQuestion} returns this
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.setDisplayOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated FormOption options = 5;
 * @return {!Array<!proto.tprmquestionnaire.FormOption>}
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.FormOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.FormOption, 5));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.FormOption>} value
 * @return {!proto.tprmquestionnaire.AnsweredQuestion} returns this
*/
proto.tprmquestionnaire.AnsweredQuestion.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.tprmquestionnaire.FormOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.FormOption}
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.tprmquestionnaire.FormOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.AnsweredQuestion} returns this
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};


/**
 * repeated ConditionRule depends_on = 6;
 * @return {!Array<!proto.tprmquestionnaire.ConditionRule>}
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.getDependsOnList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ConditionRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ConditionRule, 6));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ConditionRule>} value
 * @return {!proto.tprmquestionnaire.AnsweredQuestion} returns this
*/
proto.tprmquestionnaire.AnsweredQuestion.prototype.setDependsOnList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.tprmquestionnaire.ConditionRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ConditionRule}
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.addDependsOn = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.tprmquestionnaire.ConditionRule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.AnsweredQuestion} returns this
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.clearDependsOnList = function() {
  return this.setDependsOnList([]);
};


/**
 * optional string answer_value = 7;
 * @return {string}
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.getAnswerValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.AnsweredQuestion} returns this
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.setAnswerValue = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated AnsweredQuestionAttachment attachments = 8;
 * @return {!Array<!proto.tprmquestionnaire.AnsweredQuestionAttachment>}
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.getAttachmentsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.AnsweredQuestionAttachment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.AnsweredQuestionAttachment, 8));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.AnsweredQuestionAttachment>} value
 * @return {!proto.tprmquestionnaire.AnsweredQuestion} returns this
*/
proto.tprmquestionnaire.AnsweredQuestion.prototype.setAttachmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.tprmquestionnaire.AnsweredQuestionAttachment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.AnsweredQuestionAttachment}
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.addAttachments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.tprmquestionnaire.AnsweredQuestionAttachment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.AnsweredQuestion} returns this
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.clearAttachmentsList = function() {
  return this.setAttachmentsList([]);
};


/**
 * optional string supplemental_text = 9;
 * @return {string}
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.getSupplementalText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.AnsweredQuestion} returns this
 */
proto.tprmquestionnaire.AnsweredQuestion.prototype.setSupplementalText = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.AnsweredQuestionAttachment.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.AnsweredQuestionAttachment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.AnsweredQuestionAttachment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.AnsweredQuestionAttachment.toObject = function(includeInstance, msg) {
  var f, obj = {
    attachmentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contentId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fileName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    mimeType: jspb.Message.getFieldWithDefault(msg, 4, ""),
    uploadedAtMs: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.AnsweredQuestionAttachment}
 */
proto.tprmquestionnaire.AnsweredQuestionAttachment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.AnsweredQuestionAttachment;
  return proto.tprmquestionnaire.AnsweredQuestionAttachment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.AnsweredQuestionAttachment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.AnsweredQuestionAttachment}
 */
proto.tprmquestionnaire.AnsweredQuestionAttachment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttachmentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUploadedAtMs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.AnsweredQuestionAttachment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.AnsweredQuestionAttachment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.AnsweredQuestionAttachment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.AnsweredQuestionAttachment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttachmentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUploadedAtMs();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string attachment_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.AnsweredQuestionAttachment.prototype.getAttachmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.AnsweredQuestionAttachment} returns this
 */
proto.tprmquestionnaire.AnsweredQuestionAttachment.prototype.setAttachmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string content_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.AnsweredQuestionAttachment.prototype.getContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.AnsweredQuestionAttachment} returns this
 */
proto.tprmquestionnaire.AnsweredQuestionAttachment.prototype.setContentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_name = 3;
 * @return {string}
 */
proto.tprmquestionnaire.AnsweredQuestionAttachment.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.AnsweredQuestionAttachment} returns this
 */
proto.tprmquestionnaire.AnsweredQuestionAttachment.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string mime_type = 4;
 * @return {string}
 */
proto.tprmquestionnaire.AnsweredQuestionAttachment.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.AnsweredQuestionAttachment} returns this
 */
proto.tprmquestionnaire.AnsweredQuestionAttachment.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 uploaded_at_ms = 5;
 * @return {number}
 */
proto.tprmquestionnaire.AnsweredQuestionAttachment.prototype.getUploadedAtMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.AnsweredQuestionAttachment} returns this
 */
proto.tprmquestionnaire.AnsweredQuestionAttachment.prototype.setUploadedAtMs = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.AnsweredSection.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.AnsweredSection.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.AnsweredSection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.AnsweredSection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.AnsweredSection.toObject = function(includeInstance, msg) {
  var f, obj = {
    sectionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    displayOrder: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dependsOnList: jspb.Message.toObjectList(msg.getDependsOnList(),
    proto.tprmquestionnaire.ConditionRule.toObject, includeInstance),
    questionsList: jspb.Message.toObjectList(msg.getQuestionsList(),
    proto.tprmquestionnaire.AnsweredQuestion.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.AnsweredSection}
 */
proto.tprmquestionnaire.AnsweredSection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.AnsweredSection;
  return proto.tprmquestionnaire.AnsweredSection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.AnsweredSection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.AnsweredSection}
 */
proto.tprmquestionnaire.AnsweredSection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSectionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayOrder(value);
      break;
    case 4:
      var value = new proto.tprmquestionnaire.ConditionRule;
      reader.readMessage(value,proto.tprmquestionnaire.ConditionRule.deserializeBinaryFromReader);
      msg.addDependsOn(value);
      break;
    case 5:
      var value = new proto.tprmquestionnaire.AnsweredQuestion;
      reader.readMessage(value,proto.tprmquestionnaire.AnsweredQuestion.deserializeBinaryFromReader);
      msg.addQuestions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.AnsweredSection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.AnsweredSection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.AnsweredSection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.AnsweredSection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSectionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDisplayOrder();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDependsOnList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.tprmquestionnaire.ConditionRule.serializeBinaryToWriter
    );
  }
  f = message.getQuestionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.tprmquestionnaire.AnsweredQuestion.serializeBinaryToWriter
    );
  }
};


/**
 * optional string section_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.AnsweredSection.prototype.getSectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.AnsweredSection} returns this
 */
proto.tprmquestionnaire.AnsweredSection.prototype.setSectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.tprmquestionnaire.AnsweredSection.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.AnsweredSection} returns this
 */
proto.tprmquestionnaire.AnsweredSection.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 display_order = 3;
 * @return {number}
 */
proto.tprmquestionnaire.AnsweredSection.prototype.getDisplayOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.AnsweredSection} returns this
 */
proto.tprmquestionnaire.AnsweredSection.prototype.setDisplayOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated ConditionRule depends_on = 4;
 * @return {!Array<!proto.tprmquestionnaire.ConditionRule>}
 */
proto.tprmquestionnaire.AnsweredSection.prototype.getDependsOnList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ConditionRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ConditionRule, 4));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ConditionRule>} value
 * @return {!proto.tprmquestionnaire.AnsweredSection} returns this
*/
proto.tprmquestionnaire.AnsweredSection.prototype.setDependsOnList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.tprmquestionnaire.ConditionRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ConditionRule}
 */
proto.tprmquestionnaire.AnsweredSection.prototype.addDependsOn = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.tprmquestionnaire.ConditionRule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.AnsweredSection} returns this
 */
proto.tprmquestionnaire.AnsweredSection.prototype.clearDependsOnList = function() {
  return this.setDependsOnList([]);
};


/**
 * repeated AnsweredQuestion questions = 5;
 * @return {!Array<!proto.tprmquestionnaire.AnsweredQuestion>}
 */
proto.tprmquestionnaire.AnsweredSection.prototype.getQuestionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.AnsweredQuestion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.AnsweredQuestion, 5));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.AnsweredQuestion>} value
 * @return {!proto.tprmquestionnaire.AnsweredSection} returns this
*/
proto.tprmquestionnaire.AnsweredSection.prototype.setQuestionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.tprmquestionnaire.AnsweredQuestion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.AnsweredQuestion}
 */
proto.tprmquestionnaire.AnsweredSection.prototype.addQuestions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.tprmquestionnaire.AnsweredQuestion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.AnsweredSection} returns this
 */
proto.tprmquestionnaire.AnsweredSection.prototype.clearQuestionsList = function() {
  return this.setQuestionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest;
  return proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string questionnaire_request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest} returns this
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.VendorQuestionnaireVersionSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    versionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    submittedAtMs: jspb.Message.getFieldWithDefault(msg, 2, 0),
    submittedByName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    questionsAnswered: jspb.Message.getFieldWithDefault(msg, 4, 0),
    questionsTotal: jspb.Message.getFieldWithDefault(msg, 5, 0),
    attachedDocumentsCount: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireVersionSummary}
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.VendorQuestionnaireVersionSummary;
  return proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.VendorQuestionnaireVersionSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireVersionSummary}
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubmittedAtMs(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubmittedByName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionsAnswered(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionsTotal(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttachedDocumentsCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.VendorQuestionnaireVersionSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubmittedAtMs();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSubmittedByName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQuestionsAnswered();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getQuestionsTotal();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getAttachedDocumentsCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional string version_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.prototype.getVersionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireVersionSummary} returns this
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.prototype.setVersionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 submitted_at_ms = 2;
 * @return {number}
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.prototype.getSubmittedAtMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireVersionSummary} returns this
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.prototype.setSubmittedAtMs = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string submitted_by_name = 3;
 * @return {string}
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.prototype.getSubmittedByName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireVersionSummary} returns this
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.prototype.setSubmittedByName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 questions_answered = 4;
 * @return {number}
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.prototype.getQuestionsAnswered = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireVersionSummary} returns this
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.prototype.setQuestionsAnswered = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 questions_total = 5;
 * @return {number}
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.prototype.getQuestionsTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireVersionSummary} returns this
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.prototype.setQuestionsTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 attached_documents_count = 6;
 * @return {number}
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.prototype.getAttachedDocumentsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireVersionSummary} returns this
 */
proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.prototype.setAttachedDocumentsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    versionsList: jspb.Message.toObjectList(msg.getVersionsList(),
    proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse;
  return proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tprmquestionnaire.VendorQuestionnaireVersionSummary;
      reader.readMessage(value,proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.deserializeBinaryFromReader);
      msg.addVersions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tprmquestionnaire.VendorQuestionnaireVersionSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated VendorQuestionnaireVersionSummary versions = 1;
 * @return {!Array<!proto.tprmquestionnaire.VendorQuestionnaireVersionSummary>}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.prototype.getVersionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.VendorQuestionnaireVersionSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.VendorQuestionnaireVersionSummary, 1));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.VendorQuestionnaireVersionSummary>} value
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse} returns this
*/
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.prototype.setVersionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tprmquestionnaire.VendorQuestionnaireVersionSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireVersionSummary}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.prototype.addVersions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tprmquestionnaire.VendorQuestionnaireVersionSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse} returns this
 */
proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.prototype.clearVersionsList = function() {
  return this.setVersionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    versionId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest;
  return proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string questionnaire_request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest} returns this
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string version_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest.prototype.getVersionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest} returns this
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest.prototype.setVersionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    displayId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sectionsList: jspb.Message.toObjectList(msg.getSectionsList(),
    proto.tprmquestionnaire.AnsweredSection.toObject, includeInstance),
    submittedAtMs: jspb.Message.getFieldWithDefault(msg, 4, 0),
    submittedByName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    questionsTotal: jspb.Message.getFieldWithDefault(msg, 6, 0),
    questionsAnswered: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse;
  return proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.tprmquestionnaire.AnsweredSection;
      reader.readMessage(value,proto.tprmquestionnaire.AnsweredSection.deserializeBinaryFromReader);
      msg.addSections(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubmittedAtMs(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubmittedByName(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionsTotal(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionsAnswered(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisplayId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.tprmquestionnaire.AnsweredSection.serializeBinaryToWriter
    );
  }
  f = message.getSubmittedAtMs();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getSubmittedByName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getQuestionsTotal();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getQuestionsAnswered();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string display_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.getDisplayId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.setDisplayId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated AnsweredSection sections = 3;
 * @return {!Array<!proto.tprmquestionnaire.AnsweredSection>}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.getSectionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.AnsweredSection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.AnsweredSection, 3));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.AnsweredSection>} value
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse} returns this
*/
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.setSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.tprmquestionnaire.AnsweredSection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.AnsweredSection}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.addSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.tprmquestionnaire.AnsweredSection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.clearSectionsList = function() {
  return this.setSectionsList([]);
};


/**
 * optional int64 submitted_at_ms = 4;
 * @return {number}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.getSubmittedAtMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.setSubmittedAtMs = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string submitted_by_name = 5;
 * @return {string}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.getSubmittedByName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.setSubmittedByName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 questions_total = 6;
 * @return {number}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.getQuestionsTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.setQuestionsTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 questions_answered = 7;
 * @return {number}
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.getQuestionsAnswered = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.prototype.setQuestionsAnswered = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    sectionsList: jspb.Message.toObjectList(msg.getSectionsList(),
    proto.tprmquestionnaire.AnsweredSection.toObject, includeInstance),
    submittedAtMs: jspb.Message.getFieldWithDefault(msg, 5, 0),
    submittedByName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    questionsTotal: jspb.Message.getFieldWithDefault(msg, 7, 0),
    questionsAnswered: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse;
  return proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = new proto.tprmquestionnaire.AnsweredSection;
      reader.readMessage(value,proto.tprmquestionnaire.AnsweredSection.deserializeBinaryFromReader);
      msg.addSections(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubmittedAtMs(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubmittedByName(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionsTotal(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionsAnswered(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.tprmquestionnaire.AnsweredSection.serializeBinaryToWriter
    );
  }
  f = message.getSubmittedAtMs();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSubmittedByName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getQuestionsTotal();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getQuestionsAnswered();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.getDisplayId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.setDisplayId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated AnsweredSection sections = 4;
 * @return {!Array<!proto.tprmquestionnaire.AnsweredSection>}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.getSectionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.AnsweredSection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.AnsweredSection, 4));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.AnsweredSection>} value
 * @return {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse} returns this
*/
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.setSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.tprmquestionnaire.AnsweredSection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.AnsweredSection}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.addSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.tprmquestionnaire.AnsweredSection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.clearSectionsList = function() {
  return this.setSectionsList([]);
};


/**
 * optional int64 submitted_at_ms = 5;
 * @return {number}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.getSubmittedAtMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.setSubmittedAtMs = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string submitted_by_name = 6;
 * @return {string}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.getSubmittedByName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.setSubmittedByName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 questions_total = 7;
 * @return {number}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.getQuestionsTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.setQuestionsTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 questions_answered = 8;
 * @return {number}
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.getQuestionsAnswered = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.prototype.setQuestionsAnswered = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.Comment.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.Comment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.Comment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.Comment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sectionNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
    questionNumber: jspb.Message.getFieldWithDefault(msg, 4, 0),
    authorSide: jspb.Message.getFieldWithDefault(msg, 5, 0),
    authorDisplayName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    body: jspb.Message.getFieldWithDefault(msg, 7, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 8, 0),
    isDraft: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.Comment}
 */
proto.tprmquestionnaire.Comment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.Comment;
  return proto.tprmquestionnaire.Comment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.Comment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.Comment}
 */
proto.tprmquestionnaire.Comment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSectionNumber(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionNumber(value);
      break;
    case 5:
      var value = /** @type {!proto.tprmquestionnaire.QuestionnaireCommentAuthorSide} */ (reader.readEnum());
      msg.setAuthorSide(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorDisplayName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDraft(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.Comment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.Comment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.Comment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.Comment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getAuthorSide();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getAuthorDisplayName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getIsDraft();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.Comment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string questionnaire_request_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.Comment.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 section_number = 3;
 * @return {number}
 */
proto.tprmquestionnaire.Comment.prototype.getSectionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setSectionNumber = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.clearSectionNumber = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.Comment.prototype.hasSectionNumber = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 question_number = 4;
 * @return {number}
 */
proto.tprmquestionnaire.Comment.prototype.getQuestionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setQuestionNumber = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.clearQuestionNumber = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.Comment.prototype.hasQuestionNumber = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional QuestionnaireCommentAuthorSide author_side = 5;
 * @return {!proto.tprmquestionnaire.QuestionnaireCommentAuthorSide}
 */
proto.tprmquestionnaire.Comment.prototype.getAuthorSide = function() {
  return /** @type {!proto.tprmquestionnaire.QuestionnaireCommentAuthorSide} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.tprmquestionnaire.QuestionnaireCommentAuthorSide} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setAuthorSide = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string author_display_name = 6;
 * @return {string}
 */
proto.tprmquestionnaire.Comment.prototype.getAuthorDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setAuthorDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string body = 7;
 * @return {string}
 */
proto.tprmquestionnaire.Comment.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 created_at = 8;
 * @return {number}
 */
proto.tprmquestionnaire.Comment.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool is_draft = 9;
 * @return {boolean}
 */
proto.tprmquestionnaire.Comment.prototype.getIsDraft = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setIsDraft = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.CreateCommentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.CreateCommentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.CreateCommentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sectionNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    questionNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
    body: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.CreateCommentRequest}
 */
proto.tprmquestionnaire.CreateCommentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.CreateCommentRequest;
  return proto.tprmquestionnaire.CreateCommentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.CreateCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.CreateCommentRequest}
 */
proto.tprmquestionnaire.CreateCommentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSectionNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionNumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.CreateCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.CreateCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.CreateCommentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string questionnaire_request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 section_number = 2;
 * @return {number}
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.getSectionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.CreateCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.setSectionNumber = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.CreateCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.clearSectionNumber = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.hasSectionNumber = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 question_number = 3;
 * @return {number}
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.getQuestionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.CreateCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.setQuestionNumber = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.CreateCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.clearQuestionNumber = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.hasQuestionNumber = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string body = 4;
 * @return {string}
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListCommentThreadRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListCommentThreadRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListCommentThreadRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sectionNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    questionNumber: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListCommentThreadRequest}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListCommentThreadRequest;
  return proto.tprmquestionnaire.ListCommentThreadRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListCommentThreadRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListCommentThreadRequest}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSectionNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListCommentThreadRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListCommentThreadRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListCommentThreadRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string questionnaire_request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ListCommentThreadRequest} returns this
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 section_number = 2;
 * @return {number}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.getSectionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ListCommentThreadRequest} returns this
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.setSectionNumber = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.ListCommentThreadRequest} returns this
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.clearSectionNumber = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.hasSectionNumber = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 question_number = 3;
 * @return {number}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.getQuestionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ListCommentThreadRequest} returns this
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.setQuestionNumber = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.ListCommentThreadRequest} returns this
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.clearQuestionNumber = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.hasQuestionNumber = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ListCommentThreadResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListCommentThreadResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListCommentThreadResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListCommentThreadResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListCommentThreadResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    commentsList: jspb.Message.toObjectList(msg.getCommentsList(),
    proto.tprmquestionnaire.Comment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListCommentThreadResponse}
 */
proto.tprmquestionnaire.ListCommentThreadResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListCommentThreadResponse;
  return proto.tprmquestionnaire.ListCommentThreadResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListCommentThreadResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListCommentThreadResponse}
 */
proto.tprmquestionnaire.ListCommentThreadResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tprmquestionnaire.Comment;
      reader.readMessage(value,proto.tprmquestionnaire.Comment.deserializeBinaryFromReader);
      msg.addComments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListCommentThreadResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListCommentThreadResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListCommentThreadResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListCommentThreadResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tprmquestionnaire.Comment.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Comment comments = 1;
 * @return {!Array<!proto.tprmquestionnaire.Comment>}
 */
proto.tprmquestionnaire.ListCommentThreadResponse.prototype.getCommentsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.Comment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.Comment, 1));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.Comment>} value
 * @return {!proto.tprmquestionnaire.ListCommentThreadResponse} returns this
*/
proto.tprmquestionnaire.ListCommentThreadResponse.prototype.setCommentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tprmquestionnaire.Comment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.Comment}
 */
proto.tprmquestionnaire.ListCommentThreadResponse.prototype.addComments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tprmquestionnaire.Comment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ListCommentThreadResponse} returns this
 */
proto.tprmquestionnaire.ListCommentThreadResponse.prototype.clearCommentsList = function() {
  return this.setCommentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.Empty.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.Empty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.Empty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.Empty.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.Empty}
 */
proto.tprmquestionnaire.Empty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.Empty;
  return proto.tprmquestionnaire.Empty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.Empty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.Empty}
 */
proto.tprmquestionnaire.Empty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.Empty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.Empty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.Empty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.Empty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.FormOptionInput.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.FormOptionInput.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.FormOptionInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.FormOptionInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormOptionInput.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    label: jspb.Message.getFieldWithDefault(msg, 2, ""),
    supplementalList: jspb.Message.toObjectList(msg.getSupplementalList(),
    proto.tprmquestionnaire.SupplementalInput.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.FormOptionInput}
 */
proto.tprmquestionnaire.FormOptionInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.FormOptionInput;
  return proto.tprmquestionnaire.FormOptionInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.FormOptionInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.FormOptionInput}
 */
proto.tprmquestionnaire.FormOptionInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = new proto.tprmquestionnaire.SupplementalInput;
      reader.readMessage(value,proto.tprmquestionnaire.SupplementalInput.deserializeBinaryFromReader);
      msg.addSupplemental(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.FormOptionInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.FormOptionInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.FormOptionInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormOptionInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSupplementalList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.tprmquestionnaire.SupplementalInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.FormOptionInput.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormOptionInput} returns this
 */
proto.tprmquestionnaire.FormOptionInput.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.tprmquestionnaire.FormOptionInput.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormOptionInput} returns this
 */
proto.tprmquestionnaire.FormOptionInput.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated SupplementalInput supplemental = 3;
 * @return {!Array<!proto.tprmquestionnaire.SupplementalInput>}
 */
proto.tprmquestionnaire.FormOptionInput.prototype.getSupplementalList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.SupplementalInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.SupplementalInput, 3));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.SupplementalInput>} value
 * @return {!proto.tprmquestionnaire.FormOptionInput} returns this
*/
proto.tprmquestionnaire.FormOptionInput.prototype.setSupplementalList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.tprmquestionnaire.SupplementalInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.SupplementalInput}
 */
proto.tprmquestionnaire.FormOptionInput.prototype.addSupplemental = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.tprmquestionnaire.SupplementalInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.FormOptionInput} returns this
 */
proto.tprmquestionnaire.FormOptionInput.prototype.clearSupplementalList = function() {
  return this.setSupplementalList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.FormSectionInput.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.FormSectionInput.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.FormSectionInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.FormSectionInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormSectionInput.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    dependsOnList: jspb.Message.toObjectList(msg.getDependsOnList(),
    proto.tprmquestionnaire.ConditionRule.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.FormSectionInput}
 */
proto.tprmquestionnaire.FormSectionInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.FormSectionInput;
  return proto.tprmquestionnaire.FormSectionInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.FormSectionInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.FormSectionInput}
 */
proto.tprmquestionnaire.FormSectionInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = new proto.tprmquestionnaire.ConditionRule;
      reader.readMessage(value,proto.tprmquestionnaire.ConditionRule.deserializeBinaryFromReader);
      msg.addDependsOn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.FormSectionInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.FormSectionInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.FormSectionInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormSectionInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDependsOnList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.tprmquestionnaire.ConditionRule.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.FormSectionInput.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormSectionInput} returns this
 */
proto.tprmquestionnaire.FormSectionInput.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.tprmquestionnaire.FormSectionInput.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormSectionInput} returns this
 */
proto.tprmquestionnaire.FormSectionInput.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.tprmquestionnaire.FormSectionInput.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormSectionInput} returns this
 */
proto.tprmquestionnaire.FormSectionInput.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated ConditionRule depends_on = 4;
 * @return {!Array<!proto.tprmquestionnaire.ConditionRule>}
 */
proto.tprmquestionnaire.FormSectionInput.prototype.getDependsOnList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ConditionRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ConditionRule, 4));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ConditionRule>} value
 * @return {!proto.tprmquestionnaire.FormSectionInput} returns this
*/
proto.tprmquestionnaire.FormSectionInput.prototype.setDependsOnList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.tprmquestionnaire.ConditionRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ConditionRule}
 */
proto.tprmquestionnaire.FormSectionInput.prototype.addDependsOn = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.tprmquestionnaire.ConditionRule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.FormSectionInput} returns this
 */
proto.tprmquestionnaire.FormSectionInput.prototype.clearDependsOnList = function() {
  return this.setDependsOnList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.FormQuestionInput.repeatedFields_ = [4,5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.FormQuestionInput.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.FormQuestionInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.FormQuestionInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormQuestionInput.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    text: jspb.Message.getFieldWithDefault(msg, 2, ""),
    responseType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.tprmquestionnaire.FormOptionInput.toObject, includeInstance),
    supplementalList: jspb.Message.toObjectList(msg.getSupplementalList(),
    proto.tprmquestionnaire.SupplementalInput.toObject, includeInstance),
    dependsOnList: jspb.Message.toObjectList(msg.getDependsOnList(),
    proto.tprmquestionnaire.ConditionRule.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.FormQuestionInput}
 */
proto.tprmquestionnaire.FormQuestionInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.FormQuestionInput;
  return proto.tprmquestionnaire.FormQuestionInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.FormQuestionInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.FormQuestionInput}
 */
proto.tprmquestionnaire.FormQuestionInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 3:
      var value = /** @type {!proto.tprmquestionnaire.QuestionResponseType} */ (reader.readEnum());
      msg.setResponseType(value);
      break;
    case 4:
      var value = new proto.tprmquestionnaire.FormOptionInput;
      reader.readMessage(value,proto.tprmquestionnaire.FormOptionInput.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    case 5:
      var value = new proto.tprmquestionnaire.SupplementalInput;
      reader.readMessage(value,proto.tprmquestionnaire.SupplementalInput.deserializeBinaryFromReader);
      msg.addSupplemental(value);
      break;
    case 6:
      var value = new proto.tprmquestionnaire.ConditionRule;
      reader.readMessage(value,proto.tprmquestionnaire.ConditionRule.deserializeBinaryFromReader);
      msg.addDependsOn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.FormQuestionInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.FormQuestionInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.FormQuestionInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormQuestionInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getResponseType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.tprmquestionnaire.FormOptionInput.serializeBinaryToWriter
    );
  }
  f = message.getSupplementalList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.tprmquestionnaire.SupplementalInput.serializeBinaryToWriter
    );
  }
  f = message.getDependsOnList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.tprmquestionnaire.ConditionRule.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.FormQuestionInput.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormQuestionInput} returns this
 */
proto.tprmquestionnaire.FormQuestionInput.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.tprmquestionnaire.FormQuestionInput.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormQuestionInput} returns this
 */
proto.tprmquestionnaire.FormQuestionInput.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional QuestionResponseType response_type = 3;
 * @return {!proto.tprmquestionnaire.QuestionResponseType}
 */
proto.tprmquestionnaire.FormQuestionInput.prototype.getResponseType = function() {
  return /** @type {!proto.tprmquestionnaire.QuestionResponseType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.tprmquestionnaire.QuestionResponseType} value
 * @return {!proto.tprmquestionnaire.FormQuestionInput} returns this
 */
proto.tprmquestionnaire.FormQuestionInput.prototype.setResponseType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated FormOptionInput options = 4;
 * @return {!Array<!proto.tprmquestionnaire.FormOptionInput>}
 */
proto.tprmquestionnaire.FormQuestionInput.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.FormOptionInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.FormOptionInput, 4));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.FormOptionInput>} value
 * @return {!proto.tprmquestionnaire.FormQuestionInput} returns this
*/
proto.tprmquestionnaire.FormQuestionInput.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.tprmquestionnaire.FormOptionInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.FormOptionInput}
 */
proto.tprmquestionnaire.FormQuestionInput.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.tprmquestionnaire.FormOptionInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.FormQuestionInput} returns this
 */
proto.tprmquestionnaire.FormQuestionInput.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};


/**
 * repeated SupplementalInput supplemental = 5;
 * @return {!Array<!proto.tprmquestionnaire.SupplementalInput>}
 */
proto.tprmquestionnaire.FormQuestionInput.prototype.getSupplementalList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.SupplementalInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.SupplementalInput, 5));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.SupplementalInput>} value
 * @return {!proto.tprmquestionnaire.FormQuestionInput} returns this
*/
proto.tprmquestionnaire.FormQuestionInput.prototype.setSupplementalList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.tprmquestionnaire.SupplementalInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.SupplementalInput}
 */
proto.tprmquestionnaire.FormQuestionInput.prototype.addSupplemental = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.tprmquestionnaire.SupplementalInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.FormQuestionInput} returns this
 */
proto.tprmquestionnaire.FormQuestionInput.prototype.clearSupplementalList = function() {
  return this.setSupplementalList([]);
};


/**
 * repeated ConditionRule depends_on = 6;
 * @return {!Array<!proto.tprmquestionnaire.ConditionRule>}
 */
proto.tprmquestionnaire.FormQuestionInput.prototype.getDependsOnList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ConditionRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ConditionRule, 6));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ConditionRule>} value
 * @return {!proto.tprmquestionnaire.FormQuestionInput} returns this
*/
proto.tprmquestionnaire.FormQuestionInput.prototype.setDependsOnList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.tprmquestionnaire.ConditionRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ConditionRule}
 */
proto.tprmquestionnaire.FormQuestionInput.prototype.addDependsOn = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.tprmquestionnaire.ConditionRule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.FormQuestionInput} returns this
 */
proto.tprmquestionnaire.FormQuestionInput.prototype.clearDependsOnList = function() {
  return this.setDependsOnList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    category: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    csv: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest}
 */
proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest;
  return proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest}
 */
proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCsv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCsv();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string category = 2;
 * @return {string}
 */
proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string csv = 4;
 * @return {string}
 */
proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.prototype.getCsv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireTemplateRequest.prototype.setCsv = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    csv: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse}
 */
proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse;
  return proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse}
 */
proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCsv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCsv();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string csv = 1;
 * @return {string}
 */
proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse.prototype.getCsv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireCsvTemplateResponse.prototype.setCsv = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireTemplateId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest}
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest;
  return proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest}
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireTemplateId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireTemplateId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string questionnaire_template_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest.prototype.getQuestionnaireTemplateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailRequest.prototype.setQuestionnaireTemplateId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    template: (f = msg.getTemplate()) && proto.tprmquestionnaire.QuestionnaireTemplate.toObject(includeInstance, f),
    form: (f = msg.getForm()) && proto.tprmquestionnaire.QuestionnaireForm.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse}
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse;
  return proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse}
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tprmquestionnaire.QuestionnaireTemplate;
      reader.readMessage(value,proto.tprmquestionnaire.QuestionnaireTemplate.deserializeBinaryFromReader);
      msg.setTemplate(value);
      break;
    case 2:
      var value = new proto.tprmquestionnaire.QuestionnaireForm;
      reader.readMessage(value,proto.tprmquestionnaire.QuestionnaireForm.deserializeBinaryFromReader);
      msg.setForm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTemplate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.tprmquestionnaire.QuestionnaireTemplate.serializeBinaryToWriter
    );
  }
  f = message.getForm();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.tprmquestionnaire.QuestionnaireForm.serializeBinaryToWriter
    );
  }
};


/**
 * optional QuestionnaireTemplate template = 1;
 * @return {?proto.tprmquestionnaire.QuestionnaireTemplate}
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.prototype.getTemplate = function() {
  return /** @type{?proto.tprmquestionnaire.QuestionnaireTemplate} */ (
    jspb.Message.getWrapperField(this, proto.tprmquestionnaire.QuestionnaireTemplate, 1));
};


/**
 * @param {?proto.tprmquestionnaire.QuestionnaireTemplate|undefined} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse} returns this
*/
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.prototype.setTemplate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.prototype.clearTemplate = function() {
  return this.setTemplate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.prototype.hasTemplate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional QuestionnaireForm form = 2;
 * @return {?proto.tprmquestionnaire.QuestionnaireForm}
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.prototype.getForm = function() {
  return /** @type{?proto.tprmquestionnaire.QuestionnaireForm} */ (
    jspb.Message.getWrapperField(this, proto.tprmquestionnaire.QuestionnaireForm, 2));
};


/**
 * @param {?proto.tprmquestionnaire.QuestionnaireForm|undefined} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse} returns this
*/
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.prototype.setForm = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.prototype.clearForm = function() {
  return this.setForm(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.GetQuestionnaireTemplateDetailResponse.prototype.hasForm = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireTemplateId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    category: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest}
 */
proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest;
  return proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest}
 */
proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireTemplateId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireTemplateId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string questionnaire_template_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.prototype.getQuestionnaireTemplateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest} returns this
 */
proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.prototype.setQuestionnaireTemplateId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest} returns this
 */
proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string category = 3;
 * @return {string}
 */
proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest} returns this
 */
proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest} returns this
 */
proto.tprmquestionnaire.UpdateQuestionnaireTemplateMetaRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireTemplateId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest}
 */
proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest;
  return proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest}
 */
proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireTemplateId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireTemplateId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string questionnaire_template_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest.prototype.getQuestionnaireTemplateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest} returns this
 */
proto.tprmquestionnaire.DuplicateQuestionnaireTemplateRequest.prototype.setQuestionnaireTemplateId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireTemplateId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest}
 */
proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest;
  return proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest}
 */
proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireTemplateId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireTemplateId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string questionnaire_template_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest.prototype.getQuestionnaireTemplateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest} returns this
 */
proto.tprmquestionnaire.DeleteQuestionnaireTemplateRequest.prototype.setQuestionnaireTemplateId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireFormId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    section: (f = msg.getSection()) && proto.tprmquestionnaire.FormSectionInput.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest}
 */
proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest;
  return proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest}
 */
proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormId(value);
      break;
    case 2:
      var value = new proto.tprmquestionnaire.FormSectionInput;
      reader.readMessage(value,proto.tprmquestionnaire.FormSectionInput.deserializeBinaryFromReader);
      msg.setSection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireFormId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSection();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.tprmquestionnaire.FormSectionInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional string questionnaire_form_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest.prototype.getQuestionnaireFormId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest} returns this
 */
proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest.prototype.setQuestionnaireFormId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional FormSectionInput section = 2;
 * @return {?proto.tprmquestionnaire.FormSectionInput}
 */
proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest.prototype.getSection = function() {
  return /** @type{?proto.tprmquestionnaire.FormSectionInput} */ (
    jspb.Message.getWrapperField(this, proto.tprmquestionnaire.FormSectionInput, 2));
};


/**
 * @param {?proto.tprmquestionnaire.FormSectionInput|undefined} value
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest} returns this
*/
proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest.prototype.setSection = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest} returns this
 */
proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest.prototype.clearSection = function() {
  return this.setSection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.SaveQuestionnaireFormSectionRequest.prototype.hasSection = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireFormSectionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    question: (f = msg.getQuestion()) && proto.tprmquestionnaire.FormQuestionInput.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest}
 */
proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest;
  return proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest}
 */
proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormSectionId(value);
      break;
    case 2:
      var value = new proto.tprmquestionnaire.FormQuestionInput;
      reader.readMessage(value,proto.tprmquestionnaire.FormQuestionInput.deserializeBinaryFromReader);
      msg.setQuestion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireFormSectionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestion();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.tprmquestionnaire.FormQuestionInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional string questionnaire_form_section_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest.prototype.getQuestionnaireFormSectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest} returns this
 */
proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest.prototype.setQuestionnaireFormSectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional FormQuestionInput question = 2;
 * @return {?proto.tprmquestionnaire.FormQuestionInput}
 */
proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest.prototype.getQuestion = function() {
  return /** @type{?proto.tprmquestionnaire.FormQuestionInput} */ (
    jspb.Message.getWrapperField(this, proto.tprmquestionnaire.FormQuestionInput, 2));
};


/**
 * @param {?proto.tprmquestionnaire.FormQuestionInput|undefined} value
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest} returns this
*/
proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest.prototype.setQuestion = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest} returns this
 */
proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest.prototype.clearQuestion = function() {
  return this.setQuestion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest.prototype.hasQuestion = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireFormSectionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest}
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest;
  return proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest}
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormSectionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireFormSectionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string questionnaire_form_section_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest.prototype.getQuestionnaireFormSectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest} returns this
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest.prototype.setQuestionnaireFormSectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireFormQuestionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest}
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest;
  return proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest}
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormQuestionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireFormQuestionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string questionnaire_form_question_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest.prototype.getQuestionnaireFormQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest} returns this
 */
proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest.prototype.setQuestionnaireFormQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireFormId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orderedSectionIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest}
 */
proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest;
  return proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest}
 */
proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addOrderedSectionIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireFormId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderedSectionIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string questionnaire_form_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.prototype.getQuestionnaireFormId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest} returns this
 */
proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.prototype.setQuestionnaireFormId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string ordered_section_ids = 2;
 * @return {!Array<string>}
 */
proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.prototype.getOrderedSectionIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest} returns this
 */
proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.prototype.setOrderedSectionIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest} returns this
 */
proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.prototype.addOrderedSectionIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest} returns this
 */
proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest.prototype.clearOrderedSectionIdsList = function() {
  return this.setOrderedSectionIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireFormQuestionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    toSectionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    toIndex: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest}
 */
proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest;
  return proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest}
 */
proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormQuestionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setToSectionId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setToIndex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireFormQuestionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getToSectionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getToIndex();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string questionnaire_form_question_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest.prototype.getQuestionnaireFormQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest} returns this
 */
proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest.prototype.setQuestionnaireFormQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string to_section_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest.prototype.getToSectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest} returns this
 */
proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest.prototype.setToSectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 to_index = 3;
 * @return {number}
 */
proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest.prototype.getToIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest} returns this
 */
proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest.prototype.setToIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest;
  return proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string questionnaire_request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest} returns this
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsRequest.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.VendorQuestionnaireAttachment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.VendorQuestionnaireAttachment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.toObject = function(includeInstance, msg) {
  var f, obj = {
    attachmentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contentId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fileName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    mimeType: jspb.Message.getFieldWithDefault(msg, 4, ""),
    sectionNumber: jspb.Message.getFieldWithDefault(msg, 5, 0),
    sectionName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    questionNumber: jspb.Message.getFieldWithDefault(msg, 7, 0),
    questionId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    questionText: jspb.Message.getFieldWithDefault(msg, 9, ""),
    answerValue: jspb.Message.getFieldWithDefault(msg, 10, ""),
    uploadedAtMs: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireAttachment}
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.VendorQuestionnaireAttachment;
  return proto.tprmquestionnaire.VendorQuestionnaireAttachment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.VendorQuestionnaireAttachment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireAttachment}
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttachmentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSectionNumber(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSectionName(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionNumber(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionText(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerValue(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUploadedAtMs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.VendorQuestionnaireAttachment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.VendorQuestionnaireAttachment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttachmentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSectionNumber();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getSectionName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getQuestionNumber();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getQuestionId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getQuestionText();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAnswerValue();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getUploadedAtMs();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
};


/**
 * optional string attachment_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.getAttachmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.setAttachmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string content_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.getContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.setContentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_name = 3;
 * @return {string}
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string mime_type = 4;
 * @return {string}
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 section_number = 5;
 * @return {number}
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.getSectionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.setSectionNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string section_name = 6;
 * @return {string}
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.getSectionName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.setSectionName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 question_number = 7;
 * @return {number}
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.getQuestionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.setQuestionNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string question_id = 8;
 * @return {string}
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.getQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string question_text = 9;
 * @return {string}
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.getQuestionText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.setQuestionText = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string answer_value = 10;
 * @return {string}
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.getAnswerValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.setAnswerValue = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int64 uploaded_at_ms = 11;
 * @return {number}
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.getUploadedAtMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.VendorQuestionnaireAttachment.prototype.setUploadedAtMs = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.tprmquestionnaire.VendorQuestionnaireAttachment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse;
  return proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tprmquestionnaire.VendorQuestionnaireAttachment;
      reader.readMessage(value,proto.tprmquestionnaire.VendorQuestionnaireAttachment.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tprmquestionnaire.VendorQuestionnaireAttachment.serializeBinaryToWriter
    );
  }
};


/**
 * repeated VendorQuestionnaireAttachment items = 1;
 * @return {!Array<!proto.tprmquestionnaire.VendorQuestionnaireAttachment>}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.VendorQuestionnaireAttachment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.VendorQuestionnaireAttachment, 1));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.VendorQuestionnaireAttachment>} value
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse} returns this
*/
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tprmquestionnaire.VendorQuestionnaireAttachment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.VendorQuestionnaireAttachment}
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tprmquestionnaire.VendorQuestionnaireAttachment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse} returns this
 */
proto.tprmquestionnaire.ListVendorQuestionnaireAttachmentsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    attachmentId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest}
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest;
  return proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest}
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttachmentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAttachmentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string questionnaire_request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest} returns this
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string attachment_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest.prototype.getAttachmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest} returns this
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentRequest.prototype.setAttachmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    file: msg.getFile_asB64(),
    fileName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mimeType: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse}
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse;
  return proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse}
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFile(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFile_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional bytes file = 1;
 * @return {!(string|Uint8Array)}
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.prototype.getFile = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes file = 1;
 * This is a type-conversion wrapper around `getFile()`
 * @return {string}
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.prototype.getFile_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFile()));
};


/**
 * optional bytes file = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFile()`
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.prototype.getFile_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFile()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse} returns this
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.prototype.setFile = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional string file_name = 2;
 * @return {string}
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse} returns this
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string mime_type = 3;
 * @return {string}
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse} returns this
 */
proto.tprmquestionnaire.DownloadVendorQuestionnaireAttachmentResponse.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * @enum {number}
 */
proto.tprmquestionnaire.QuestionResponseType = {
  FREE_TEXT: 0,
  SINGLE_SELECT: 1,
  MULTI_SELECT: 2,
  FILE_UPLOAD: 3
};

/**
 * @enum {number}
 */
proto.tprmquestionnaire.SupplementalInputKind = {
  SUPPLEMENTAL_UNSPECIFIED: 0,
  TEXT_INFO: 1,
  ATTACHMENT: 2
};

/**
 * @enum {number}
 */
proto.tprmquestionnaire.QuestionnaireCommentAuthorSide = {
  AUTHOR_SIDE_UNSPECIFIED: 0,
  CUSTOMER: 1,
  VENDOR: 2
};

goog.object.extend(exports, proto.tprmquestionnaire);
